// Personal content stays here. Portfolio entries are compiled from the curated
// content and the validated GitHub snapshot; do not edit the generated catalog.
import projectCatalog from './projects.generated.json';

export const person = {
  name: 'Keyan Fayaz',
  initial: 'KF',
  role: 'Software Engineer',
  location: 'San Diego, CA',
  year: '2026',
  email: 'contact@kfayaz.com',
  twitter: 'kfayazinc',
  linkedin: 'k-fayaz',
  github: 'keyanfayaz',
  bio: "I'm a software engineer at Abalta. My work has moved from research and development to product engineering for connected devices. In my free time, I build my own projects and do AI and software consulting through Orche Strategies.",
  longBio: [
    "At Abalta, I work on software for connected devices. My role has moved from research and development to product engineering.",
    'In my free time, I build my own projects and do AI and software consulting through Orche Strategies.',
    'Earlier, I developed software for service robots in banking and education.',
  ],
};

export const aboutHighlights = [
  "I've worked on software for connected devices, AI systems, and service robots.",
  "I care about how people use the software I build.",
  "I like sharing what I learn and working with other people.",
];

export const now = [
  { label: 'Engineering', text: "I work on software for connected devices, AI systems, and service robots." },
  { label: 'Consulting', text: "I do AI and software consulting through Orche Strategies in my free time." },
  { label: 'Building', text: 'Workplace Agents, tools for customers, and consulting for small teams.' },
  { label: 'Thinking about', text: "How can AI help people without taking away their work or control?" },
  { label: 'Off-screen', text: 'Hockey, ultimate frisbee, the beach, the park, walking the dog.' },
  { label: 'Always', text: 'Reading slowly. Writing things down. Tinkering with something new.' },
];

export const projects = projectCatalog.filter((project) => !project.static);

export const getProjectBySlug = (slug) => projects.find((project) => project.slug === slug);

const groupDefinitions = [
  ['products', 'Products'],
  ['ventures', 'Ventures'],
  ['projects-open-source', "Projects and open source"],
  ['career', 'Career'],
];

export const workGroups = groupDefinitions.map(([id, title]) => ({
  id,
  title,
  items: projectCatalog.filter((project) => project.group === id && project.listed !== false),
}));

// Homepage copy; current work confirmed by Keyan for the personal-site redesign.
export const homepage = {
  intro: "I'm a software engineer in San Diego. I build software for work, and sometimes for fun.",
  background: 'Earlier, I developed software for service robots in banking and education.',
  interests: "I'm interested in technology, productivity, and how people experience the things they use.",
  outside: 'I like bike rides, hockey, ultimate frisbee, and time at the beach or the park with my dog.',
  offscreen: "I also like music, life hacks, and learning new things.",
};
